"use client";

import Image from "next/image";
import React from "react";
import heroImage from "@/assets/images/hero-image.png";
import { useGetHero } from "@/components/parts/admin/hero/api";

const HeroSection = () => {
  const { data } = useGetHero();
  const hero = data?.data;
  return (
    <figure className="h-[calc(100vh-6.6rem)] container flex lg:flex-row flex-col-reverse items-center lg:justify-between justify-evenly gap-6 pt-10 pb-10">
      <figcaption className="max-w-3xl text-left">
        <div className="text-secondary-400 font-semibold text-2xl md:text-5xl">
          <h1>
            SELAMAT DATANG{" "}
            <span className="text-primary-700">
              SISTEM INFORMASI MANAJEMEN RESES
            </span>{" "}
            DPRD KAB PALI
          </h1>
        </div>
        <div className="mt-4 md:mt-7 md:text-base text-sm">
          <p>{hero?.description}</p>
        </div>
      </figcaption>
      <Image
        src={hero?.imageUrl ?? heroImage}
        height={800}
        width={800}
        alt="hero-image"
        className="sm:w-[589px] w-80 h-auto object-contain sm:object-fill"
      />
    </figure>
  );
};

export default HeroSection;
